import { useEffect, useState } from 'react';

import type { MapRef } from 'react-map-gl/mapbox';

import useGetCurrentZoom from '@/hooks/use-get-current-zoom';

// TODO: needs to replace useState with useRef
export function useZoomThreshold(mapRef: MapRef | null | undefined, threshold: number) {
  const [isPastThreshold, setIsPastThreshold] = useState(false);

  const { currentZoom } = useGetCurrentZoom();

  useEffect(() => {
    if (!mapRef) {
      return;
    }

    setIsPastThreshold(currentZoom.current >= threshold);

    const handleCameraUpdate = () => {
      const isCurrentlyPast = currentZoom.current >= threshold;

      setIsPastThreshold(isCurrentlyPast);
    };

    mapRef.on('zoom', handleCameraUpdate);

    return () => {
      mapRef.off('zoom', handleCameraUpdate);
    };
  }, [mapRef, currentZoom, threshold]);

  return isPastThreshold;
}
